import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import error401Svg from '../assets/img/errors/error-401.svg';
import error404Img from '../assets/img/errors/error-404.png';
import error500Img from '../assets/img/errors/error-500.png';
import { useOptionalSession } from '../contexts/SessionContext';

/** @type {(type: 404 | 401 | 500) => string } */
const getErrorImage = (type) => {
  if (type === 401) {
    return error401Svg;
  }
  if (type === 404) {
    return error404Img;
  }
  return error500Img;
};

/**
 * @typedef { object } Props
 * @prop { string= } title
 * @prop { string= } message
 * @prop { (404 | 401 | 500)= } type
 */

/** @type { React.FC<Props> } */
const ErrorPage = ({ title, message, type = 500 }) => {
  const { session } = useOptionalSession();

  const logoSrc = session?.logoUrl;

  return (
    (<Box
      component="main"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        py: '80px',
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 6,
          }}
        >
          <Box
            alt="Internal server error"
            component="img"
            src={getErrorImage(type)}
            sx={{
              height: 'auto',
              maxWidth: '100%',
              width: 'auto',
              maxHeight: '390px',
              mb: 6,
            }}
          />
        </Box>

        <Typography align="center" variant="h4" component="h1" gutterBottom>
          {title || 'Something went wrong'}
        </Typography>
        <Typography
          align="center"
          sx={{
            color: "text.secondary",
            mt: 0.5
          }}>
          {message ||
            'There was an error and the app cant figure out what to display. Try restarting your journey from Home.'}
        </Typography>

        {logoSrc && (
          <Box
            component="img"
            src={logoSrc}
            sx={{
              mx: "auto",
              mt: 6,
              height: 'auto',
              maxWidth: '100%',
              maxHeight: '40px'
            }} />
        )}
      </Container>
    </Box>)
  );
};

export default ErrorPage;
